import {registerGraphNode} from "#graph/decorators/register-node"
import {fixedValueNodeDefinition} from "#graph/nodes/fixed-value/definition"
import {GraphNode} from "#graph/nodes/graph/graph-node"
import {lazyDefinition} from "#graph/helpers/lazy-definition"
import {z} from "zod/v4-mini"

const fixedValueDefinition = lazyDefinition(() => fixedValueNodeDefinition("FixedValue", z.any()))
const numberValueDefinition = lazyDefinition(() => fixedValueNodeDefinition("NumberValue", z.number()))
const stringValueDefinition = lazyDefinition(() => fixedValueNodeDefinition("StringValue", z.string()))
const mixedOutputDefinition = lazyDefinition(() => fixedValueNodeDefinition("MixedOutput", z.object({a: z.number(), b: z.string()})))

@registerGraphNode
export class FixedValue<ValueType, Context> extends GraphNode<ValueType, Context, {value: ValueType}> {
    public override get definition() {
        return fixedValueDefinition()
    }

    override run = async (): Promise<ValueType> => {
        return this.parameters.value
    }

    override runSync = (): ValueType => {
        return this.parameters.value
    }
}

@registerGraphNode
export class NumberValue<Context = unknown> extends FixedValue<number, Context> {
    public override get definition() {
        return numberValueDefinition()
    }
}

@registerGraphNode
export class StringValue<Context = unknown> extends FixedValue<string, Context> {
    public override get definition() {
        return stringValueDefinition()
    }
}

@registerGraphNode
export class MixedOutput<Context = unknown> extends FixedValue<{a: number; b: string}, Context> {
    public override get definition() {
        return mixedOutputDefinition()
    }
}
